/** @format */

import React, { useMemo, useRef, useState } from "react";
import moment from "moment";
import _ from "lodash";
import { IconButton, Button, TextField, Link, Typography, LinearProgress } from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import { NeedIcon, NeedListItem, AcuityNeedItem } from "../TransferIcons";
import { getOriginLocationString, getDestinationLocationString, getTimeFromDate,getTimeFromDatebyZone } from "../../../common/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { TimelineCommandType } from "../types/plannerTypes";
import { RootState } from "../../../store/rootReducer";
import CompassIcon from "../helpers/CompassIcon";
import { tripPointerPosition } from "./plannerHelpers";
import { IVirtualTrip, ITransferTask } from "../../../common/plannerTypes";
import { ISchedule } from "../../../common/types";
import { useDrop, useDrag, DropTargetMonitor } from "react-dnd";
import { XYCoord } from "dnd-core";
import { showTripDetailsModal } from "../../../store/modules/plannerSliceModals";
import { copyVirtualTrip } from "./virtualTripHelpers";
import { useDispatch } from "react-redux";
import { checkAcuity, checkuserpermission } from "../conflictNotices/conflictNoticeHelper";
import { ConflictDialogData, ConflictType, IntervalNumbers } from "../types/conflictNoticeTypes";
import { getData, getRoles, persistName, setData } from "../helpers/transferScheduleHelpers";
import { consts } from "../../../common/consts";
import { Controller } from "react-hook-form/dist/controller";
import { color } from "html2canvas/dist/types/css/types/color";
import api from "../../../store/api";
import { setLoading } from "../../../store/modules/plannerLoadingSlice";
import { Height } from "@material-ui/icons";
export const MODAL_TYPE = {
  DROP_TO_ADD: "DROP_TO_ADD",
  CANNOT_ADD: "CANNOT_ADD",
  TRIP_DETAILS: "TRIP_DETAILS",
  PLAN_TRIP: "PLAN_TRIP",
};

const PRIORTY_OPTION = [3, 2, 1];

interface TripCheckPoint {
  pickUp: boolean;
  dropOff: boolean;
  time: Date;
  colour: string;
  name: string;
  key: string;
  transferId: string;
  customerLocationtimezone : string
}

interface TripCheckPointDnd {
  trip: TripCheckPoint;
  index: number;
}

const COLOURS_LIST = ["#236B84", "#601C84", "#3D841C", "#846D1C", "#841C3B", "#2A1C84"];

const SeatIcon = () => {
  return (
    <div style={{ marginRight: 13, marginLeft: 1 }}>
      <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.98684 7.47253V7.69231C9.98684 8.02198 9.71595 8.2967 9.39088 8.2967H2.85338L3.0701 9.65201C3.12427 9.89011 3.32293 10.0549 3.5577 10.0549H9.5173C9.82431 10.0549 10.0591 10.348 9.98684 10.6593L9.57148 12.4176C9.5173 12.6374 9.31864 12.8022 9.10193 12.8022H2.00459C1.75176 12.8022 1.55311 12.6374 1.51699 12.3993L0 3.2967V3.20513V0.494505C0 0.21978 0.216713 0 0.487603 0H1.51699C1.78788 0 2.00459 0.21978 2.00459 0.494505V3.05861V3.13187L2.61861 6.86813H9.39088C9.71595 6.86813 9.98684 7.14286 9.98684 7.47253ZM2.27548 16.6667H8.90328C9.22835 16.6667 9.48118 16.4103 9.49924 16.0623V15.8425C9.49924 15.5128 9.24641 15.2564 8.92134 15.2564H2.27548C1.95041 15.2564 1.69758 15.5128 1.69758 15.8425V16.0806C1.69758 16.4103 1.95041 16.6667 2.27548 16.6667Z"
          fill="black"
        />
      </svg>
    </div>
  );
};
const StretcherIcon = () => {
  return (
    <div style={{ marginRight: 10 }}>
      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.74771 0C1.42597 0 1.16514 0.26455 1.16514 0.590778V1.77233C1.16514 2.09862 1.42597 2.36311 1.74771 2.36311H4.078C4.39975 2.36311 4.66057 2.09862 4.66057 1.77233V0.590778C4.66057 0.26455 4.39975 0 4.078 0H1.74771ZM0 4.72622C0 5.05251 0.260823 5.317 0.582571 5.317H13.3993C13.721 5.317 13.9818 5.05251 13.9818 4.72622V3.54466C13.9818 3.21844 13.721 2.95389 13.3993 2.95389H0.582571C0.260823 2.95389 0 3.21844 0 3.54466V4.72622ZM12.2523 9.45534C11.8074 9.45534 11.4066 9.62814 11.0985 9.9045L8.19759 8.26805L11.3493 6.49572H8.94911L6.99749 7.59445L5.05171 6.49572H2.65151L5.80322 8.27378L2.9019 9.90421C2.59384 9.62814 2.19321 9.45534 1.74853 9.45534C0.781461 9.45534 0.0008156 10.2469 0.0008156 11.2277C0.0008156 12.2024 0.781461 13 1.74853 13C2.51141 13 3.15165 12.5007 3.39074 11.8127H10.61C10.8492 12.5007 11.4894 13 12.2523 13C13.2194 13 14 12.2024 14 11.2277C14 10.2469 13.2194 9.45534 12.2523 9.45534ZM1.74853 11.8127C1.42811 11.8127 1.16596 11.5528 1.16596 11.2219C1.16596 10.8968 1.42811 10.6312 1.74853 10.6312C2.06894 10.6312 2.3311 10.8968 2.3311 11.2219C2.3311 11.5528 2.06894 11.8127 1.74853 11.8127ZM6.99749 8.94738L4.0089 10.6312H9.99191L6.99749 8.94738ZM12.2523 11.8127C11.9319 11.8127 11.6697 11.5528 11.6697 11.2219C11.6697 10.8968 11.9319 10.6312 12.2523 10.6312C12.5727 10.6312 12.8349 10.8968 12.8349 11.2219C12.8349 11.5528 12.5727 11.8127 12.2523 11.8127Z"
          fill="#333333"
        />
      </svg>
    </div>
  );
};

const TripDetailsHeader = ({ priorityOption, setPriorityOption, reArrangeTrips, estimationTime,triplaner,setLoad,tripDetails,applyTimelineChanges,showTripDetailsModal,setErrorMessage }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { authStore } = useSelector((state: RootState) => state);
  var minutes = "";
  const [Overrideminute, setOverrideminute] = useState("");
  const [showAdjustMin, setShowAdjustMin] = useState(true);
  const [showClearAdjustMin, setShowClearAdjustMin] = useState(false);
  const [showMinControl, setShowMinControl] = useState(false);
  const [estTime, setEstTime] = useState(estimationTime);
  const [overRideEstTime, setOverRideEstTime] = useState(estimationTime);
  const [etaHrs, setEtaHrs] = useState(Math.floor(estimationTime / 60));
  const [etaMins, setEtaMins] = useState(estimationTime % 60);
  const [disableButton, setDisableButton] = useState(false);
  const saveButtonRef = useRef<HTMLSpanElement>(null); 
  const textFieldRef = useRef<HTMLInputElement>(null);

  const handleTabClick = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Tab') {
      event.preventDefault(); 
      if (saveButtonRef.current) {
        saveButtonRef.current.focus(); 
      }
    }
  };

  var userperHeader = null;
  var role = "";
  if (triplaner === null) {
    role = consts.Permissions.Primary;
  }
  else {
    role = triplaner;
  }
  var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
  if (superuser !== true) {
    if (authStore.data?.IsAdmin || authStore.data?.IsSMAUser) {
      userperHeader = checkuserpermission(triplaner, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
        some((p) => (p == consts.Permissions.SMAModifytripplansorderofstops || p == consts.Permissions.SMARescheduletrips))) : (Boolean(authStore.data?.role.split(",")?.some((p) => (p == consts.Permissions.SMAModifytripplansorderofstopsSecondary || p == consts.Permissions.SMARescheduletripsSecondary)))));
    }
    else {
      userperHeader = checkuserpermission(triplaner, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
        some((p) => (p == consts.Permissions.Modifytripplansorderofstops || p == consts.Permissions.Rescheduletrips))) : (Boolean(authStore.data?.role.split(",")?.some((p) => (p == consts.Permissions.ModifytripplansorderofstopsSecondary || p == consts.Permissions.RescheduletripsSecondary)))));
    }
  }
  

  const handleInputMinuteChange = (event: any) => {
    minutes = event.target.value;
    if(minutes != '0')
        setOverrideminute(minutes);
  };

  const OnSaveOverrideMin = async (event:any,IsClearAdjustment: any) => {
    try {
      if((Overrideminute === '' && Overrideminute.length === 0) || !IsClearAdjustment){
        setErrorMessage("Please enter Adjustment duration.");
      }
        
      
      if ((Overrideminute !== '' && Overrideminute.length > 0) || IsClearAdjustment) {
        setLoad(true)
        const virtualTrip = copyVirtualTrip(tripDetails);

        if(IsClearAdjustment){
          setOverrideminute("");
          setShowAdjustMin(true)
          setShowClearAdjustMin(false)
          setShowMinControl(false)
          virtualTrip.isTripMinOverrided = false
          virtualTrip.overrideTripEstimateInMin = 0
          setEstTime(Number(estimationTime ?? tripDetails?.estimatedDurationInMunutes))
          setOverRideEstTime(Number(estimationTime ?? tripDetails?.estimatedDurationInMunutes))
        }
        else {
          virtualTrip.isTripMinOverrided = true
          virtualTrip.overrideTripEstimateInMin = Number(Overrideminute) ?? 0
          setDisableButton(true)
          setShowAdjustMin(false)
          setShowClearAdjustMin(true)
          setShowMinControl(false)
          setEstTime(Number(estimationTime ?? tripDetails?.estimatedDurationInMunutes))
          setOverRideEstTime(Number(tripDetails?.overrideTripEstimateInMin))
        }
        dispatch(
          showTripDetailsModal({
            showTripDetails: false,
            tripDetails: null,
            tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
            blockLabel: null,
          })
        );
        applyTimelineChanges(tripDetails, {
          type: TimelineCommandType.overrideTrip,
          tripUpdates: virtualTrip,
        });

        setLoad(false)
      }
    } catch (error) {
      setLoad(false)
      console.error(error);
    }
  };

  const GetOverrideDetails = async () => {
    try {
      setLoad(true)
      setShowAdjustMin(false)
      setShowClearAdjustMin(false)
      setShowMinControl(false)
     
          if (tripDetails?.isTripMinOverrided) {
            setEstTime(Number(estimationTime ?? tripDetails?.estimatedDurationInMunutes))
            setOverRideEstTime(Number(tripDetails?.overrideTripEstimateInMin))
            setShowClearAdjustMin(true)
            setShowAdjustMin(false)
            setShowMinControl(false)
          }
          else {
            setEstTime(Number(estimationTime ?? tripDetails?.estimatedDurationInMunutes))
            setOverRideEstTime(Number(estimationTime ?? tripDetails?.estimatedDurationInMunutes))
            setShowAdjustMin(true)
            setShowClearAdjustMin(false)
            setShowMinControl(false)
          }
      setLoad(false)
    } catch (error) {
      setLoad(false)
      console.error(error);
    }
  };

  React.useEffect(() => {
    if (authStore.data?.IsSMAUser && overRideEstTime) {
      var etaHrs = Math.floor(overRideEstTime / 60);
      setEtaHrs(etaHrs);
      var etaMins = overRideEstTime % 60;
      setEtaMins(etaMins);
    }
  }, [overRideEstTime]);


  React.useEffect(() => {
    if(authStore.data?.IsSMAUser){
      GetOverrideDetails();
    }
  }, []);

  // Function to handle key press event and allow only numbers
  const handleKeyPress = (event:any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumber = /\d/.test(keyValue);
    if (!isNumber) {
      event.preventDefault();
    }
  };

  const handlePaste = (event:any) => {
    event.preventDefault(); // Prevent default paste behavior
  };

  return (
    <div className={classes.headerTripDetails}>
      <div className={classes.priorityBlock}>
        <span className={classes.priorityText}>Priority</span>
        <ToggleButtonGroup
          color="primary"
          exclusive
          onChange={(e, v) => {
            setPriorityOption(v);
          }}
          size={"small"}
          value={priorityOption}
          classes={{
            root: classes.pickupDropoffContainer,
          }}
        >
          {PRIORTY_OPTION.map((p) => (
            <ToggleButton
              key={p}
              value={p}
              disableRipple
              classes={{
                root: classes.priorityToggleRoot,
                selected: classes.priorityToggleSelected,
                label: classes.priorityToggleLabel,
              }}
            >
              {p}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
      {showAdjustMin && (<div className={classes.tripDuration}>
        Trip duration
        &nbsp;
        <span>
          {etaHrs > 0 && ` ${etaHrs} hr`} {`${etaMins} Minutes`}
        </span>
        &nbsp;
        {authStore.data?.IsSMAUser && (
        <span>
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              setDisableButton(false)
              setShowAdjustMin(false)
              setShowMinControl(true)
              setShowClearAdjustMin(false)
            }}
            className={classes.txtLink}
          >
            Adjust
          </Link>
        </span>)}
      </div>)}

      {showClearAdjustMin && (<div className={classes.tripDuration}>
        Adjusted Trip duration
        &nbsp;
        <span>
          {etaHrs > 0 && ` ${etaHrs} hr`} {`${etaMins} Minutes`}
        </span>
        &nbsp;
        <span>
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              OnSaveOverrideMin(null, true)
            }}
            className={classes.txtLink}
          >
            Clear Adjustment
          </Link>
        </span>
      </div>)}

      {showMinControl && (<div className={classes.tripDurationControls}>
        Duration
        <TextField
          classes={{ root: classes.durationinput }}
          inputProps={{ maxLength: 3, style: { height: '8px' }, onKeyPress: handleKeyPress, onKeyDown: handleTabClick }} variant='outlined'
          InputProps={{ classes: { root: classes.outlinedDurationInput } }}
          placeholder='Minutes'
          value={String(Overrideminute)}
          onChange={handleInputMinuteChange}
          onPaste={handlePaste}
          ref={textFieldRef}
        />
        <span 
          ref={saveButtonRef}
          onClick={(e) => {
            OnSaveOverrideMin(null, false)
          }}
          className={classes.saveButton} style={{ pointerEvents: disableButton ? 'none' : 'visible' }} 
          tabIndex={-1}
          >
          Save
        </span>
        <Link
          component="button"
          variant="body2"
          onClick={() => {
            setOverrideminute("");
            setShowAdjustMin(true)
            setShowMinControl(false)
            setShowClearAdjustMin(false)
          }}
          className={classes.txtLink}
        >
          Cancel
        </Link>
      </div>)}

      {userperHeader === null ?
        <Button variant="outlined" onClick={reArrangeTrips} className={classes.reArrageButton} disableRipple disableTouchRipple>
          Re-arrange Trip
        </Button>
        : null}

    </div>
  );
};

const TripReArrangeTripsHeader = ({ goBack, estimationTime }: any) => {
  const classes = useStyles();
  const etaHrs = Math.floor(estimationTime / 60);
  const etaMins = estimationTime % 60;

  return (
    <div className={classes.headerTripDetails}>
      <IconButton aria-label="remove" size="small" classes={{ root: classes.backArrowButton }} onClick={goBack}>
        <ArrowBackIcon fontSize="small" />
      </IconButton>
      <div className={classes.tripDuration}>
        Trip duration
        <span>
          {etaHrs > 0 && ` ${etaHrs} hr`} {`${etaMins} Minutes`}
        </span>
      </div>
    </div>
  );
};


const RearrangeTripPill = ({ tcp, index, movePill, applyChanges }: { tcp: TripCheckPoint; index: number; movePill: any; applyChanges: any }) => {
  const classes = useStyles();
  const ref = React.useRef<HTMLDivElement>(null);

  const [{ handlerId }, drop] = useDrop({
    accept: "TripRearrange",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item: TripCheckPointDnd, monitor: DropTargetMonitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();

      // Get horizontal middle
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      // Get pixels to the left
      const hoverClientX = (clientOffset as XYCoord).x - hoverBoundingRect.left;

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
        return;
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
        return;
      }

      // Time to actually perform the action
      const isMoved = movePill(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      if (isMoved) {
        item.index = hoverIndex;
      }
    },
    drop() {
      applyChanges();
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "TripRearrange",
    item: () => {
      return { trip: tcp, index };
    },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div ref={ref} className={classes.tripPillContainer} style={{ opacity: opacity }} data-handler-id={handlerId}>
      <div ref={drag} className={classes.tripPill} style={{ backgroundColor: tcp.colour }}>
        <div className={classes.tripIcon}>
          <MenuIcon fontSize="inherit" />
        </div>
        <div className={classes.tripPatientName}>
          {tcp.pickUp ? "Pickup " : "Dropoff "}
          {tcp.name}
        </div>
        <div className={classes.tripTime}>{moment(tcp.time).format("kk:mm")}</div>
      </div>
    </div>
  );
};

const PlannerTripDetails = ({ minuteWidth, quarterMinuteWidth, hourWidth, timelineContent, blockLabel, applyTimelineChanges,triplaner,setErrorMessage }: any) => {
  const { plannerModalStore } = useSelector((state: RootState) => state);
  const { plannerStore } = useSelector((state: RootState) => state);
  const [load, setLoad] = React.useState(false);
   const tripDetailsTemp = plannerStore.visualState.filter((vTrip) => {
   const transferIds = vTrip.transfers.map((t) => t.transferId);
     if (_.includes(transferIds, plannerModalStore?.tripDetails?.transfers[0].transferId)) {
      return true;
    }
    return false;
  });
  const tripDetails = tripDetailsTemp[0] as IVirtualTrip;

  const modalTypeInit = plannerModalStore.tripDetailsModalType;
  const pointerLeftPosition = useMemo(() => {
    let resultPosition = 0;
    if (plannerModalStore.showTripDetails && tripDetails) {
      let endTimeValue = tripDetails.endTrip;
      if (tripDetails?.isTripMinOverrided && tripDetails.overridedendTrip) {
        endTimeValue = tripDetails.overridedendTrip;
      }
      resultPosition = tripPointerPosition(minuteWidth, quarterMinuteWidth, hourWidth, timelineContent, tripDetails.startTrip, endTimeValue);
    }
    return resultPosition;
  }, [
    plannerModalStore.showTripDetails, tripDetails, minuteWidth, quarterMinuteWidth, hourWidth, timelineContent
  ]);

  const [priorityOption, setPriorityOption] = useState(tripDetails?.transfers[0].scheduleObj.priority || 1);
  const [modalType, setModalType] = useState(modalTypeInit ?? MODAL_TYPE.TRIP_DETAILS);
  const estimationTime = tripDetails?.transfers[0].scheduleObj.estimatedDurationInMunutes || 0;
  
  const tripList: ISchedule[] = tripDetails?.transfers
 
    ? _.sortBy(
        tripDetails.transfers.map((t: any) => t.scheduleObj),
        ["lastName", "mobility"]
      )
    : [];
  const { authStore } = useSelector((state: RootState) => state);
  const [role, setRoles] = React.useState<any>(getRoles(authStore));
  const [tripCheckPointList, setTripCheckPointList] = useState<TripCheckPoint[]>([]);
  const colourRecursion = (index: number): number => {
    const coloursItemcount = COLOURS_LIST.length -1;
      if(index <= coloursItemcount){
        return index
      }
      else if(index < 0){
        return index
      }
        return colourRecursion(Math.round(index/coloursItemcount))
    }


  React.useEffect(() => {
    const tripCheckpoints: TripCheckPoint[] = [];
    const transferIdToColourAndName = new Map();
    const transferIdsSorted = tripList.map((t) => t.transferId).sort();
    tripList.forEach((t: ISchedule, index: number) => {
      transferIdToColourAndName.set(t.transferId, {
        colour: COLOURS_LIST[colourRecursion(transferIdsSorted.indexOf(t.transferId))],
        patientName: `${t.firstName && t.firstName.length > 1 ? t.firstName[0] : ""} ${t.lastName}`,
      });
    });
    tripDetails?.transferTasks.forEach((t: ITransferTask, index: number) => {
      const { colour, patientName } = transferIdToColourAndName.get(t.transferId);
      tripCheckpoints.push({
        pickUp: t.taskType === 0,
        dropOff: t.taskType === 1,
        time: t.startTime || new Date(),
        colour: colour,
        name: patientName,
        key: `${index}`,
        transferId: t.transferId,
        customerLocationtimezone: t.customerLocationtimezone,
      });
    });
    setTripCheckPointList(tripCheckpoints);

    if (!tripList || tripList.length === 0) {
      dispatch(
        showTripDetailsModal({
          showTripDetails: false,
          tripDetails: null,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: null,
        })
      );
    }
  }, [tripDetails]);

  const maxNoOfPatientSeat = plannerModalStore.noOfPatientSeats ?? 0;
  const maxNoOfStretchers = plannerModalStore.noOfStretchers ?? 0;
  const showLayerUnder = plannerModalStore.showLayerUnder ?? false;
  const noOfPatientSeatOccupied = tripList.filter((t) => t.mobility === 2).length;
  const noOfStretchersOccupied = tripList.filter((t) => t.mobility === 1).length;
  const emptySeatsNumber = maxNoOfPatientSeat - noOfPatientSeatOccupied > 0 ? maxNoOfPatientSeat - noOfPatientSeatOccupied : 0;
  const emptyStretchersNumber = maxNoOfStretchers - noOfStretchersOccupied > 0 ? maxNoOfStretchers - noOfStretchersOccupied : 0;

  const lastRowMobilityType = tripList.slice(-1)[0]?.mobility;
 
  const emptySeatstretchersList =
    lastRowMobilityType === 2
      ? [...Array(emptySeatsNumber).fill("seat"), ...Array(emptyStretchersNumber).fill("stretcher")]
      : [...Array(emptyStretchersNumber).fill("stretcher"), ...Array(emptySeatsNumber).fill("seat")];

  const dispatch = useDispatch();
  const classes = useStyles();

  React.useEffect(() => {
    setModalType(modalTypeInit ?? MODAL_TYPE.TRIP_DETAILS);
    
  }, [modalTypeInit]);

  const movePill = (dragIndex: number, hoverIndex: number): boolean => {
    const dragEl = tripCheckPointList[dragIndex];
    if (dragEl.dropOff) {
      const pickupIndex = _.findIndex(tripCheckPointList, { pickUp: true, transferId: dragEl.transferId });
      if (pickupIndex >= hoverIndex) {
        return false;
      }
    }
    if (dragEl.pickUp) {
      const dropoffIndex = _.findIndex(tripCheckPointList, { dropOff: true, transferId: dragEl.transferId });
      if (dropoffIndex <= hoverIndex) {
        return false;
      }
    }
    const tempArr = [...tripCheckPointList];

    let hoverTransferId = tempArr[hoverIndex].transferId
    let hoverTransferPickupIndex = _.findIndex(tripCheckPointList, { pickUp: true, transferId: hoverTransferId });
    let hoverTransferDropOffIndex = _.findIndex(tripCheckPointList, { dropOff: true, transferId: hoverTransferId });
    
    let hoverTransfer = tempArr[hoverIndex];
    if(hoverTransfer.dropOff && hoverTransferPickupIndex > dragIndex) {
      return false;
    }

    if(hoverTransfer.pickUp && hoverTransferDropOffIndex < dragIndex) {
      return false;
      
    }

    const tempEl = tempArr[dragIndex];
    tempArr[dragIndex] = tempArr[hoverIndex];
    tempArr[hoverIndex] = tempEl;
    setTripCheckPointList([...tempArr]);

    return true;
  };

  const GoBackTripPlanner = () => {
    localStorage.setItem('isReArranged', "false");
    setModalType(MODAL_TYPE.TRIP_DETAILS);
  }

  const onReArrangeTrip = () => {
    localStorage.setItem('isReArranged', "true");
    setModalType(MODAL_TYPE.PLAN_TRIP);
  }
  const applyPillRearrange = () => {
    const virtualTrip = copyVirtualTrip(tripDetails);
    virtualTrip.transferTasks = tripCheckPointList.map((t) => {
      const temp: ITransferTask = {
        taskType: t.pickUp ? 0 : 1,
        transferId: t.transferId,
        startTime: null,
        customerLocationtimezone: t.customerLocationtimezone,
        duration: null,
      };
      return temp;
    });

    applyTimelineChanges(tripDetails, {
      type: TimelineCommandType.applyTransferOrderChanges,
      tripUpdates: virtualTrip,
    });
  };
  var roles ="";
        if(triplaner === null)
        {
          roles =consts.Permissions.Primary;
        }
        else{
          roles =triplaner;
        }
        var userperRemove:any = null;   
        var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
        if(superuser!== true)
        { 
  if(authStore.data?.IsAdmin || authStore.data?.IsSMAUser)
  {
    userperRemove = checkuserpermission(triplaner, roles === consts.Permissions.Primary? Boolean(authStore.data?.role.split(",")?.
    some((p) => p == consts.Permissions.SMARemovetransfers)):(Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMARemovetransfersSecondary))));
  }
  else
  {
    userperRemove = checkuserpermission(triplaner, roles === consts.Permissions.Primary? Boolean(authStore.data?.role.split(",")?.
    some((p) => p == consts.Permissions.Removetransfers)):(Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.RemovetransfersSecondary))));
  }
}
  


  return (
    <>
      {plannerModalStore.showTripDetails && blockLabel == plannerModalStore.blockLabel && (
        <>
          {showLayerUnder && (
            <div
              className={classes.underLayer}
              onClick={() => {
                dispatch(
                  showTripDetailsModal({
                    showTripDetails: false,
                    tripDetails: null,
                    tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
                    blockLabel: null,
                  })
                );
              }}
            ></div>
          )}
          <div className={classes.pointer} style={{ left: pointerLeftPosition }}></div>
          <div className={classes.root}>
            {modalType === MODAL_TYPE.DROP_TO_ADD && <div className={classes.headerAdd}>Drop to add patient to trip</div>}
            {modalType === MODAL_TYPE.CANNOT_ADD && <div className={classes.headerCannotAdd}>Cannot add to trip. Trip not suitable.</div>}
            {modalType === MODAL_TYPE.TRIP_DETAILS && (
              <TripDetailsHeader
                priorityOption={priorityOption}
                setPriorityOption={setPriorityOption}
                reArrangeTrips={() => onReArrangeTrip()}
                estimationTime={estimationTime}
                triplaner ={triplaner}
                setLoad = {setLoad}
                tripDetails = {tripDetails}
                applyTimelineChanges = {applyTimelineChanges}
                showTripDetailsModal = {showTripDetailsModal}
                setErrorMessage = {setErrorMessage}

              />
            )}
            {modalType === MODAL_TYPE.PLAN_TRIP && (
              <>
                <TripReArrangeTripsHeader goBack={() => GoBackTripPlanner() } estimationTime={estimationTime} />
                <div className={classes.rearrangeTrips}>
                  {tripCheckPointList.map((tcp: TripCheckPoint, index: number) => {
                    return <RearrangeTripPill tcp={tcp} key={tcp.key} index={index} movePill={movePill} applyChanges={applyPillRearrange} />;
                  })}
                </div>
              </>
            )}

            {modalType !== MODAL_TYPE.PLAN_TRIP  && (
              <>
              <div style={{width:'100%', height:5}}>
                {load  && <LinearProgress classes={{root:classes.progress}} style={{width:'100%'}} />}
              </div>
                <div className={classes.table}>
                            
                  <div className={classes.tableHead}>
                    <div className={classes.patientColumn}>PATIENT</div>
                    <div className={classes.pickupTimeColumn}>PICKUP TIME</div>
                    <div className={classes.needsColumn}>NEEDS</div>
                    <div className={classes.fromColumn}>FROM</div>
                    <div className={classes.toColumn}>TO</div>
                    <div className={classes.actionButtonColumn}></div>
                  </div>
              
                  {tripList.map((row: ISchedule, index: number) => {
                    return (
                      <div className={classes.tableRow} key={index}>
                        <div className={classes.patientColumn}>
                          {row.mobility === 1 ? <StretcherIcon /> : <SeatIcon />}
                          <strong>
                            {row.firstName} {row.lastName}
                          </strong>
                        </div>
                        <div className={classes.pickupTimeColumn}>{getTimeFromDate(row.scheduledDate)}</div>
                        <div className={classes.needsColumn}>
                          {row.bookingSpecialNeeds.map((item: any) => (
                            <NeedIcon
                              key={row.bookingId + item.specialNeedId}
                              iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
                              theme={"light"}
                            />
                          ))}
                          {row.mobility === 1 && (
                            <NeedListItem key="notambulant" theme={"light"} text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />
                          )}
                          {row.mobility !== 1 && (
                            <NeedListItem key="ambulant" theme={"light"} text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />
                          )}
                          {row.classification && <AcuityNeedItem key="acuity" theme={"light"} text={row.classification} />}
                        </div>
                        <div className={classes.fromColumn}>{getOriginLocationString(row, true)}</div>
                        <div className={classes.toColumn}>
                          <CompassIcon angle={row.bearingAngle || 0} theme={"light"} />
                          {getDestinationLocationString(row, true)}
                        </div>
                      
                        <div className={classes.actionButtonColumn}>
                          {userperRemove === null  ?
                          <IconButton
                            aria-label="remove"
                            size="small"
                            classes={{ root: classes.removeButton }}
                            onClick={() => {
                              applyTimelineChanges(tripDetails, {
                                type: TimelineCommandType.removeFromTrip,
                                trasferIdForRemoving: row.transferId,
                              });
                              dispatch(
                                showTripDetailsModal({
                                  showTripDetails: false,
                                  tripDetails: null,
                                  tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
                                  blockLabel: null,
                                })
                              );
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton> :null
                        }                 
                        </div>
                      </div>
                    );
                  })}
                  {emptySeatstretchersList.map((item: any, index: number) => (
                    <div className={classes.tableRow} key={`empty_${index}`}>
                      <div className={classes.patientColumn}>
                        {item === "seat" ? <SeatIcon /> : <StretcherIcon />}
                        <span>Empty</span>
                      </div>
                      <div className={classes.pickupTimeColumn}></div>
                      <div className={classes.needsColumn}></div>
                      <div className={classes.fromColumn}></div>
                      <div className={classes.toColumn}></div>
                      <div className={classes.actionButtonColumn}></div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

const useStyles = makeStyles({
  progress:{
    backgroundColor:'#fff'
  },
  overlay: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1450,
  },
  root: {
    width: "calc(100% - 40px)",
    height: 251,
    position: "absolute",
    top: "-263px",
    left: 0,
    margin: "0 20px",
    zIndex: 1299,
    background: "#FFF",
    borderRadius: "4px",
  },
  duration :{
    color:'#fff'
  },
  headerAdd: {
    height: 66,
    backgroundColor: "#02489D05",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "19px",
    color: "#00152E",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerCannotAdd: {
    height: 66,
    backgroundColor: "#E05151",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "19px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerTripDetails: {
    height: 66,
    backgroundColor: "#02489D05",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  priorityBlock: {
    marginLeft: 37,
    display: "flex",
    alignItems: "center",
    flex: "0 0 260px",
  },
  priorityText: {
    marginRight: 21,
    fontSize: "16px",
    lineHeight: "19px",
    color: "#333",
  },
  pickupDropoffContainer: {
    width: "100%",
  },
  priorityToggleRoot: {
    color: "#02489D !important",
    backgroundColor: "#FFFFFF !important",
    border: "1px solid #02489D !important",
    width: "100%",
    borderRadius: "30px",
    padding: "5px",
  },
  priorityToggleSelected: {
    color: "#FFFFFF !important",
    backgroundColor: "#02489D !important",
  },
  priorityToggleLabel: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "19px",
    textAlign: "center",
    padding: "0 16px",
  },
  tripDuration: {
    fontSize: "16px",
    lineHeight: "19px",
    color: "#333",
    flex: "1",
    textAlign: "center",

    "& span": {
      fontWeight: 900,
    },
  },
  reArrageButton: {
    padding: "5px 18px",
    color: "#02489D",
    borderColor: "#02489D",
    fontSize: "15px",
    lineHeight: "18px",
    borderRadius: "4px",
    minWidth: "unset",
    marginRight: 28,
    flex: "0 0 172px",
  },
  backArrowButton: {
    marginLeft: 37,
    marginRight: 36,
    display: "flex",
    alignItems: "flex-start",
    flex: "0 0 260px",
    color: "#333",
    maxWidth: 24,
    minWidth: "unset",
  },
  table: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll",
    height: "180px",
  },
  tableHead: {
    height: 23,
    minHeight: 23,
    backgroundColor: "#02489D11",
    fontWeight: 900,
    fontSize: "12px",
    lineHeight: "14px",
    color: "#00152E",
    display: "flex",
    alignItems: "center",
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    color: "#010B18",
    height: 39,
    minHeight: 39,
    fontSize: "16px",
    lineHeight: "19px",

    "&:not(:last-child)": {
      borderBottom: "1px solid #EAEAEA",
    },
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: 33,
  },
  patientColumn: {
    paddingLeft: 27,
    flex: "1 1 200px",
    display: "flex",

    "& span": {
      color: "#010B18",
      opacity: "0.39",
    },
  },
  pickupTimeColumn: {
    paddingLeft: 15,
    flex: "0 0 110px",
  },
  needsColumn: {
    paddingLeft: 15,
    flex: "0 0 164px",
    display: "none", // "flex", SMAPT-1378
    alignItems: "center",
    "& img": {
      width: 18,
      height: 18,
    },
  },
  fromColumn: {
    paddingLeft: 15,
    flex: "1 1 318px",
  },
  toColumn: {
    paddingLeft: 15,
    flex: "1 1 318px",
    display: "flex",
  },
  actionButtonColumn: {
    paddingLeft: 15,
    paddingRight: 23,
    flex: "0 0 55px",
    display: "flex",
    justifyContent: "flex-end",
  },
  removeButton: {
    color: "#02489D",
  },
  pointer: {
    position: "absolute",
    top: "-12px",
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "8px 7px 0 7px",
    borderColor: "#ffffff transparent transparent transparent",
  },
  rearrangeTrips: {
    display: "flex",
    flexDirection: "row",
    padding: "17px 20px",
    height: "185px",
    flexWrap: "wrap",
  },
  tripPillContainer: {
    display: "flex",
    height: "44px",
    cursor: "grab",
    marginRight: "20px",
    alignItems: "center",

    "&:not(:last-child):after": {
      content: '""',
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "5px 0 5px 5.5px",
      borderColor: "transparent transparent transparent #000000",
      position: "relative",
      left: "14px",
    },
  },
  tripPill: {
    display: "flex",
    height: "44px",
    borderRadius: "4px",
    alignItems: "center",
    cursor: "grab",
  },
  noArrow: {
    "&:after": {
      display: "none",
    },
  },
  tripIcon: {
    height: "15px",
    transform: "rotate(90deg)",
    margin: "0 11px 0 13px",
    opacity: "0.56",
    fontSize: "16px",
  },
  tripPatientName: {
    fontWeight: 900,
    fontSize: "16px",
    lineHeight: "19px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "230px",
  },
  tripTime: {
    fontSize: "16px",
    lineHeight: "19px",
    padding: "0 17px",
  },
  underLayer: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1298,
  },
txtLink: {
  fontSize:"16px",
  paddingLeft:"10px"
},
durationinput:{
  padding: "1.5px 9px",
  width: "15%",
  lineHeight: "22px",
  verticalAlign:"middle",
  borderRadius: '5px',
},
outlinedDurationInput:{
  background:'#f1f1f1',
  color:'#000',
  '&:hover fieldset': {
    borderColor: 'rgba(255,255,255, 0.25)',
},
'&.Mui-focused fieldset': {
    borderColor: 'rgba(255,255,255, 0.25)!important',
    color:'#000'
},
},
tripDurationControls: {
  fontSize: "16px",
  lineHeight: "19px",
  color: "#333",
  flex: "1",
  textAlign: "center",
  marginTop: "26px",
  marginBottom: "33px",
  "& span": {
    fontWeight: 900,
  },
},
saveButton: {
  background: "#0049a3", padding: "13px 30px", fontSize: 14, fontWeight: 700, color: "#f2f5f8", borderRadius: 4, cursor: "pointer",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  verticalAlign:"middle",
},
});
export default PlannerTripDetails;
